import { createCustomError } from '@lib/errors';
import { i18n } from '@lib/i18n';
import { RegionEntity, LocationEntity } from '@modules/shared/entities';

import type { RegisterStudentAnonymouslyArgs } from '@modules/types/graphql';

export type RegisterStudentAnonymouslyFormValues = {
    region: RegionEntity | null;
    location: LocationEntity | null;
};

class RegisterStudentAnonymouslyRequest {
    regionId: RegisterStudentAnonymouslyArgs['regionId'];
    locationId: RegisterStudentAnonymouslyArgs['locationId'];
    captchaToken: RegisterStudentAnonymouslyArgs['captchaToken'];

    constructor(values: RegisterStudentAnonymouslyFormValues) {
        if (!values.region) {
            throw createCustomError(i18n.t('errors:region.invalid'));
        }
        if (!values.location) {
            throw createCustomError(i18n.t('errors:location.invalid'));
        }

        this.regionId = values.region?.id;
        this.locationId = values.location.id;
        this.captchaToken = '';
    }
}

export { RegisterStudentAnonymouslyRequest };
